export default __webpack_public_path__ + "6729c7ef867d1fe216556ae726bf0e80.png";